import React from 'react';
import { Modal, Button, Alert, Row, Col, Table, Badge } from 'react-bootstrap';

const TrackingModal = ({ show, handleClose, trackingInfo }) => {
    if (!trackingInfo) return null;
    
    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Container Tracking Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {trackingInfo.error ? (
                    <Alert variant="danger">{trackingInfo.error}</Alert>
                ) : (
                    <div className="tracking-info">
                        <Alert variant="info">
                            {trackingInfo.notice}
                        </Alert>
                        <Row className="mb-3">
                            <Col md={6}>
                                <h5>Container Details</h5>
                                <p><strong>Number:</strong> {trackingInfo.container.number}</p>
                                <p><strong>Type:</strong> {trackingInfo.container.type}</p>
                                <p><strong>Status:</strong> {trackingInfo.container.completed ? 'Completed' : 'In Transit'}</p>
                                <p><strong>Carrier:</strong> {trackingInfo.scac}</p>
                            </Col>
                            <Col md={6}>
                                <h5>Route Information</h5>
                                <p><strong>Origin:</strong> {trackingInfo.origin.port}, {trackingInfo.origin.country}</p>
                                <p><strong>Destination:</strong> {trackingInfo.destination.port}, {trackingInfo.destination.country}</p>
                                <p><strong>ETD:</strong> {trackingInfo.pol.etd_date}</p>
                                <p><strong>ETA:</strong> {trackingInfo.pod.eta_date}</p>
                            </Col>
                        </Row>
                        {trackingInfo.events && trackingInfo.events.length > 0 && (
                            <>
                                <h5>Container Events</h5>
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Location</th>
                                            <th>Action</th>
                                            <th>Transport</th>
                                            <th>Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {trackingInfo.events.map((event, idx) => (
                                            <tr key={idx} className={event.event_recent ? 'table-success' : ''}>
                                                <td>{event.event_date}</td>
                                                <td>{`${event.location.port}, ${event.location.country}`}</td>
                                                <td>{event.action.action_name}</td>
                                                <td>
                                                    {event.mode.vessel?.vessel_name ? 
                                                        `Vessel: ${event.mode.vessel.vessel_name}` : 
                                                        event.mode.transport_mode}
                                                </td>
                                                <td>
                                                    <Badge bg={event.event_type === 'actual' ? 'success' : 'warning'}>
                                                        {event.event_type}
                                                    </Badge>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </>
                        )}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TrackingModal; 